<template>
    <div class="text-sm" v-show="!loading">
        <div class="border p-4 rounded mb-4">
            <p class="uppercase text-grey">Filter</p>
            <ul class="list-reset text-grey-dark flex flex-wrap">
                <li class="mr-2 mt-2">
                    <a
                            class="border-b-2 flex text-grey-dark justify-between hover:border-blue-dark cursor-pointer"
                            v-bind:class="{'text-black border-blue-dark': allActive}"
                            @click="$emit('clear')">
                        All ({{ count }})
                    </a>
                </li>
                <li v-for="s in sources" class="mr-2 mt-2">
                    <a
                            class="border-b-2 flex text-grey-dark justify-between hover:border-blue-dark cursor-pointer"
                            v-bind:class="{'text-black border-blue-dark': s.database.key === source}"
                            @click="$emit('source', s.database.key)">
                        {{ s.database.name }} ({{ s.count }})
                    </a>
                </li>
            </ul>
        </div>

        <!--
        <ul class="list-reset">
            <li v-for="t in themes" class="">
                <a
                        class="p-2 pl-6 flex text-grey-dark justify-between hover:border-l-4 hover:border-blue-dark hover:bg-white hover:text-black"
                        v-bind:class="{'text-black border-l-4 border-blue-dark bg-white': t.database.key === theme}"
                        @click="$emit('theme', t.database.key)">
                    <div>{{ t.database.name }}</div>
                    <div>{{ t.count }}</div>
                </a>
            </li>
        </ul>
        -->
    </div>
</template>

<script>
    export default {

        name: 'Buckets',

        props: ['q', 'theme', 'source'],

        data: function () {
            return {
                sources: [],
                themes: [],
                count: 0,
                loading: true,
            };
        },

        watch: {
            q() {
                this.load();
            }
        },

        computed: {
            allActive() {
                return this.source === "all" && this.theme === 'all';
            }
        },

        created() {
            this.load();
        },

        methods: {
            load() {
                this.loading = true;
                window.http.get('/api/v1/indicators/buckets/' + this.q).then((response) => {
                    this.loading = false;
                    this.sources = response.data.sources;
                    this.themes = response.data.themes;
                    this.count = response.data.count;
                });
            },
        },

    };
</script>
